export default __webpack_public_path__ + "static/media/motocross-v2.9f195830.jpg";